import { useState, useCallback, useEffect, useRef } from "react";
import "./OnDemandVideo.scss";
import AuthService from 'services/auth.service';
import ShareScreenOnIcon from "assets/icons/video-icons/share-screen-on.svg";
import ShareScreenOffIcon from "assets/icons/video-icons/share-screen-off.svg";
import AudioOffIcon from "assets/icons/video-icons/audio-off.svg";
import AudioOnIcon from "assets/icons/video-icons/audio-on.svg";
import CameraOnIcon from "assets/icons/video-icons/camera-on.svg";
import CameraOffIcon from "assets/icons/video-icons/camera-off.svg";
import MuteIcon from "assets/icons/video-icons/white-mute-icon.svg";
import TimerIcon from "assets/icons/video-icons/timer-outline-icon.svg";
import OnDemandService from "services/on-demand.service";
import Spinner from 'react-bootstrap/Spinner';
import ZoomVideo, { ConnectionState, ReconnectReason } from "@zoom/videosdk";
import CloseVideoCallConfirmationModal from "./CloseVideoCallConfirmationModal";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { ondemandSelector, setTerminateSession } from "app/ondemandSlice";
import ChatSessionService from "services/chat-session.service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// need to change to due to zoomvideo already been defined by videosdk
export function OnDemandVideo() {
  const [loading, setLoading] = useState(false);
  const zmClient = ZoomVideo.createClient();
  const [videoStarted, setVideoStarted] = useState(true);
  const [zoomSession, setZoomSession] = useState();
  const [isMuted, setIsMuted] = useState(false);
  const [audioStarted, setAudioStarted] = useState(false);
  const [sessionEnded, setSessionEnded] = useState(null);
  const [onDemand, setOnDemand] = useState(null);
  const [token, setToken] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [userMute, setUserMute] = useState(false);
  const [showEndSessionModal, setShowEndSessionModal] = useState(false);
  const [loadingEndSession, setLoadingEndSession] = useState(false);
  const [showSessionEndedModal, setShowSessionEndedModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(null);
  const [remainingTimeLabel, setRemainingTimeLabel] = useState('');
  const [isSharingScreen, setIsSharingScreen] = useState(false);
  const [hasEndedButOngoing, setHasEndedButOngoing] = useState(false);
  const dispatch = useDispatch();
  const isCancelled = useRef(false);
  const { terminateSession } = useSelector(ondemandSelector);

  const search = window.location.search;
  const urlParams = new URLSearchParams(search);

  useEffect(() => {
    setLoading(true);
    if(urlParams && urlParams.get('on_demand_id')){
      OnDemandService.getDetails({
        id: urlParams.get('on_demand_id')
      }).then(
        (data) => {
        if(data.doctor?.id !== AuthService.getCurrentUser()?.id){
          setSessionEnded('Invalid Session');
        }else{
          setOnDemand(data);
          var current_time = moment().unix();
          var endTime = moment.unix(data?.video_session?.end_time)
          var duration = moment.duration(endTime.diff(moment.unix(current_time)));
          var getMinutes = duration.asMinutes();
          setRemainingTime(duration);
          if(getMinutes <= 0){
            setSessionEnded('Session Ended');
          }else{
            var status = data?.status;
            switch(status) {
              case 'ongoing':
                if(data?.video_session){
                  setToken(data.video_session.token)
                }
                break;
              case 'ended':
                setSessionEnded('Session Ended');
                break;
              default:
                setSessionEnded('Invalid Session');
            }
          }

          if(data?.status === 'ongoing'){
            setHasEndedButOngoing(true)
          }
         }
          setLoading(false);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      );
    }else{
      setSessionEnded('Invalid Session');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if(token){
      initial();
    }
    return () => {
      ZoomVideo.destroyClient();
    };
  }, [token]);

  useEffect(() => {
    if(zoomSession){
      zoomSession.startVideo().then(() => {
        zoomSession.attachVideo(zmClient.getCurrentUserInfo().userId, 1920).then((userVideo) => {
          document.querySelector('video-player-container').appendChild(userVideo);
          startAudioButton();
        })
      })
    }
  }, [zoomSession]);

  useEffect(() => {
    participants.forEach(function(p) {
      if (zmClient != null && zmClient.getCurrentUserInfo() != null){
        if(p.userId !== zmClient.getCurrentUserInfo().userId){
          zoomSession.renderVideo(document.querySelector('#participant-videos-canvas'), p.userId, 1920, 1080, 0, 0, 3);
          setUserMute(p?.muted);
        }
      }
    });
  }, [participants]);

  useEffect(() => {
    var timer;
    if (remainingTime === null){
      setRemainingTimeLabel(null)
    }
    else if (remainingTime > 0) {
      timer = setTimeout(() => {
        var current_time = moment().unix();
        var endTime = moment.unix(onDemand?.video_session?.end_time)
        var duration = moment.duration(endTime.diff(moment.unix(current_time)));
        setRemainingTime(duration);
        var days = duration.asDays();
        var hours = duration.asHours() % 24;
        var minutes = duration.asMinutes() % 60;
        var seconds = duration.asSeconds() % 60;
        minutes = Math.floor(minutes);
        seconds = Math.floor(seconds);

        let lbl = (minutes > 9 ? minutes : "0" + minutes) + " : " + (seconds > 9 ? seconds : "0" + seconds);

        if(lbl === '01 : 00'){
          toast("This session ends in 1 minute.",{
            progressStyle: { background: '#FF725E' } // Change to your desired color
          });
        }
        setRemainingTimeLabel(lbl);
      }, 1000);
    } else {
      setRemainingTimeLabel("Session Ended");
    }

    return () => {
      clearTimeout(timer);
    };
  }, [remainingTime]);

  useEffect(() => {
    return () => {
      isCancelled.current = true;
    };
  }, [dispatch]); // eslint-disable-line

  useEffect(() => {
    if(terminateSession){
      setTerminateSession({status: false});
      handleTerminateSession();
    }
    return () => {
      isCancelled.current = true;
    };
  }, [terminateSession]); // eslint-disable-line

  const zmNotifyUser = () => {
    const params = {
      user_id: onDemand.user.id,
      teleconsult_on_demand_id: onDemand.id
    };
    ChatSessionService.notifyUser(params).then(
      (data) => {},
      (error) => {}
    );
  };

  const startAudioButton = useCallback(async () => {
    if (audioStarted) {
      if (isMuted) {
        await zoomSession.unmuteAudio();
        setIsMuted(false);
      } else {
        await zoomSession.muteAudio();
        setIsMuted(true);
      }
    } else {
      await zoomSession.startAudio();
      setAudioStarted(true);
    }
  });

  const initial = async () => {
    await zmClient.init("en-US", "Global");

    try {
      await zmClient.join(onDemand?.video_session?.name, await token, onDemand?.doctor?.name);
      const stream = zmClient.getMediaStream();
      setZoomSession(stream);

      let participants = zmClient.getAllUser();
      setParticipants(participants)

      zmClient.on('user-added', (payload) => {
        setParticipants(zmClient.getAllUser())
      })

      zmClient.on('user-updated', (payload) => {
        if(payload?.userId !== zmClient.getCurrentUserInfo()?.userId){
          setUserMute(payload?.muted)
        }
      })

      zmClient.on('passively-stop-share', (payload) => {
        setIsSharingScreen(false);
      })      

      zmClient.on('command-channel-message', (payload) => {
        if (payload.senderName === zmClient.getCurrentUserInfo().displayName && payload.text === "host_end_all"){
          zmClient.leave(true);
        }
      })

      zmClient.on('peer-video-state-change', (payload) => {
        if (payload.action === 'Start') {
          // a user turned on their video, render it
          stream.renderVideo(document.querySelector('#participant-videos-canvas'), payload.userId, 1920, 1080, 0, 0, 3)
        } else if (payload.action === 'Stop') {
          // a user turned off their video, stop rendering it
          stream.stopRenderVideo(document.querySelector('#participant-videos-canvas'),payload.userId)
        }
      })
    } catch (err) {
      if(err?.errorCode === 200){
        setSessionEnded(err?.reason);
      }
      console.log("Error Joining Meeting", err);
    }
  };

  const startVideoButton = useCallback(async () => {
    try {
      if (videoStarted) {
        zoomSession.stopVideo().then(() => {
          zoomSession.detachVideo(zmClient.getCurrentUserInfo().userId)
        })

        setVideoStarted(false);
      } else {
        zoomSession.startVideo().then(() => {
          zoomSession.attachVideo(zmClient.getCurrentUserInfo().userId, 1920).then((userVideo) => {
            document.querySelector('video-player-container').appendChild(userVideo)
          })
        })
        setVideoStarted(true);
      }
    } catch (err) {
      console.log("Error - ", err);
    }
  });

  
  const endSession = useCallback(async () => {
    setLoadingEndSession(true);
    if(zoomSession){
      await zmClient.leave(true);
    }
    OnDemandService.end({
      id: onDemand?.id
    }).then(
      (data) => {
        setLoadingEndSession(false);
        if(data?.status === 'Success'){
          setSessionEnded('SESSION ENDED');
          setHasEndedButOngoing(false);
          setShowEndSessionModal(false);
          setShowSessionEndedModal(true);
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  });

  const endCall = useCallback(async () => {
    setLoadingEndSession(true);
    if(zoomSession){
      await zmClient.leave(true);
    }
    setLoadingEndSession(false);
    setSessionEnded("You have left the call");
    setShowEndSessionModal(false);
  });

  const shareScreenButton = useCallback(async () => {
    try {
      if(isSharingScreen){
        zoomSession.stopShareScreen();
      }else{
        if (zoomSession.isStartShareScreenWithVideoElement()) {
          await zoomSession.startShareScreen(
            document.querySelector('#my-screen-share-content-video')
          )
          // screen share successfully started and rendered
        } else {
          await zoomSession.startShareScreen(
            document.querySelector('#my-screen-share-content-canvas')
          )
          // screen share successfully started and rendered
        }
      }
      setIsSharingScreen(!isSharingScreen)
    } catch (err) {
      console.log("Error - ", err);
    }
  });

  const continueSession = () => {
    if(onDemand?.video_session){
      var current_time = moment().unix();
      var endTime = moment.unix(onDemand?.video_session?.end_time)
      var duration = moment.duration(endTime.diff(moment.unix(current_time)));
      if (duration > 0){

        zmNotifyUser();
        setSessionEnded(null)
        setToken(onDemand?.video_session.token)
        setLoadingEndSession(false);
  
        if (onDemand?.video_session.token != null){
          initial();
        }
      }else{
        setHasEndedButOngoing(false);
        setSessionEnded('Session Time Expired');
      }
    }
  };

  const SessionEndContainer = () => {
    return (
      <div className="session-end">
          <div className="font-weight-bold">{sessionEnded}</div>
          {hasEndedButOngoing && (
            <div>
              <div>
                <button className="btn session-option-rejoin-btn" onClick={() => continueSession()}>Rejoin Call</button>
                <button className="btn session-option-btn" onClick={() => {window.close()}}>Back to Teleconsult</button>
              </div>
            </div>
          )}
          {sessionEnded === "Session Time Expired" && (
            <div>
              <div>Your session has ended as the allocated time has expired.</div>
              <br />
              <div>Fell free to schedule another session in necessary</div>
              <div>
                <button className="btn session-option-btn" onClick={() => {window.close()}}>Back to Teleconsult</button>
              </div>
            </div>
          )}
        </div>
    );
  };

  const handleTerminateSession = useCallback(async () => {
    if(zoomSession){
      await zmClient.leave(true);
    }
    setHasEndedButOngoing(false);
    setSessionEnded('Session Time Expired');
  });

  return (
    <div className="zoom-video-page">
      { loading ? (
        <div className="loader">
          <Spinner animation="border" className="spinner" />
        </div>
      ) : sessionEnded ? <SessionEndContainer/> : (
        <>
          {remainingTimeLabel && <div className="countdown-timer"><img src={TimerIcon} alt="timer-icon"/>{remainingTimeLabel}</div>}
          <ToastContainer/>
          <video-player-container>
            <div className="user-identity">{(!audioStarted || isMuted) && <img src={MuteIcon} alt="mute-icon"/>} {onDemand?.doctor?.name}</div>
          </video-player-container>
          <div className="canvas-container">
            <canvas id="participant-videos-canvas" width="1920" height="1080"></canvas>
            <div className="user-identity">{userMute && <img src={MuteIcon} alt="mute-icon"/>} {onDemand?.user?.name}</div>
          </div>
          <video id="my-screen-share-content-video"></video>
          <canvas id="my-screen-share-content-canvas"></canvas>
          <div className="video-bar">
            <div className="session-name">{onDemand?.video_session?.name}</div>
            {zoomSession && (
              <div className="options-container">
                <button className="btn" onClick={() => startVideoButton()}><img src={videoStarted ? CameraOnIcon : CameraOffIcon} alt="camera-icon" /></button>
                <button className="btn" onClick={() => startAudioButton()}><img src={isMuted ? AudioOffIcon : AudioOnIcon} alt="audio-icon" /></button>
              </div>
            )}
            <button className="btn end-session-btn" onClick={() => setShowEndSessionModal(true)}>End Call</button>
          </div>
        </>
      )}
      <CloseVideoCallConfirmationModal show={showEndSessionModal} setShowEndSessionModal={setShowEndSessionModal} loadingEndSession={loadingEndSession} endCall={endCall} />
    </div>
  );
}

export default OnDemandVideo;
